//Buyerszonelist
import React, { useEffect, useState } from 'react';
import Paintingsbuycard from './Paintings/Paintingsbuycard';
import Others from './Others/Others';
import Books from './Books/Books';
import Buyerszone from './Buyerszone';
import LoadingSpinner from '../../utility/LoadingSpinner';
import { useLocation, useNavigate } from 'react-router-dom';

function Buyerszonelist() {
  const [activeTab, setActiveTab] = useState('');
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  //useeffect for tab switch
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromURL = params.get('tab'); 

    if (tabFromURL && isFirstLoad) {
      setActiveTab(tabFromURL);
      setIsFirstLoad(false);
    }
  }, [location.search, isFirstLoad]);

  //switch operation for tabs
  const renderContent = () => {
    switch (activeTab) {
      case 'Books':
        return <Books />
      case 'Paintings':
        return <Paintingsbuycard />;
      case 'Others':
        return <Others />;
      default:
        return null;
    }
  };

  //tab switch button
  const handleTabClick = (tab) => {
    setLoading(true);
    setActiveTab(tab);
    setIsFirstLoad(false);
    navigate(`/buyerszone?tab=${encodeURIComponent(tab)}`);
    setTimeout(() => {
      setLoading(false);
    }, 250);
  };

  return (
    <div className="morelist-container">
      <div className="tabs">
        {['Books', 'Paintings', 'Others'].map((category) => (
          <button
            key={category}
            onClick={() => handleTabClick(category)}
            className={activeTab === category ? 'active' : ''}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Initial Static Content */}
      {isFirstLoad ? (
        <div className="buyerszone-home">
          <Buyerszone />
        </div>
      ) : loading ? (
        <LoadingSpinner />
      ) : (
        <div>{renderContent()}</div>
      )}

    </div>
  );
}

export default Buyerszonelist;